import { render } from "./SupportMaterialTable.vue?vue&type=template&id=69b7c8d8&scoped=true"
import script from "./SupportMaterialTable.vue?vue&type=script&lang=js"
export * from "./SupportMaterialTable.vue?vue&type=script&lang=js"

import "./SupportMaterialTable.vue?vue&type=style&index=0&id=69b7c8d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b7c8d8"]])

export default __exports__